// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, loginProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitLoginProfessionalApi = createAsyncThunk("hitLoginProfessionalApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
      },
    };
    const url = ApiBaseUrl + loginProfessional;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
   showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const loginProfessionalSlice = createSlice({
  name: "loginProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitLoginProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitLoginProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitLoginProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;      
      })
      .addCase(hitLoginProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitLoginProfessionalData } = loginProfessionalSlice.actions;
export default loginProfessionalSlice.reducer;
